export const convertCanvasToBlob = (canvas) => {
    if (!canvas) return null;

    const canvasElement = canvas.renderer.view;

    canvas.render();

    return new Promise((resolve, reject) => {
        canvasElement.toBlob((blob) => {
            if (blob) {
                const blobURL = URL.createObjectURL(blob);
                resolve(blobURL);
            } else {
                reject('Failed to create a Blob from the canvas.');
            }
        }, 'image/png');
    });
}



export function clampSpriteScale(sprite, minSize, maxSize) {
  const largest = Math.max(sprite.texture.width, sprite.texture.height);
  const scaleToMin = minSize / largest;
  const scaleToMax = maxSize / largest;

  let scale = sprite.scale.x;
  scale = Math.min(Math.max(scale, scaleToMin), scaleToMax);
  sprite.scale.set(scale);
}

export const saveCanvasAsBlob = async (canvas) => {
    try {
        canvas.render();
        const blobURL = await convertCanvasToBlob(canvas);
        const link = document.createElement('a');
        link.href = blobURL;
        link.download = 'pixi_canvas.png';
        link.click();
        URL.revokeObjectURL(blobURL);
    } catch (error) {
        console.error('Error saving canvas as Blob:', error);
    }
}

export function loadStateForPIXI(pixiCanvas, stateString, callback) {
  try {
    const savedState = JSON.parse(stateString);
    // Assume your PIXI canvas has a reference to the primary display object via __textDesign
    const textDesign = pixiCanvas.__textDesign;
    if (textDesign && savedState.textDesign) {
      textDesign.x = savedState.textDesign.x;
      textDesign.y = savedState.textDesign.y;
      textDesign.width = savedState.textDesign.width;
      textDesign.height = savedState.textDesign.height;
      textDesign.rotation = savedState.textDesign.rotation;
      textDesign.scale.set(
        savedState.textDesign.scaleX,
        savedState.textDesign.scaleY
      ); 
      //add
      if (textDesign && savedState.textDesign.opacity != null) {
        textDesign.alpha = savedState.textDesign.opacity;
      }
//end
      if (
        textDesign &&
        textDesign.filters &&
        textDesign.filters[0] &&
        savedState.textDesign.wrapping
      ) {
        textDesign.filters[0].scale.set(
          savedState.textDesign.wrapping,
          savedState.textDesign.wrapping
        );
      }
      console.log("PIXI state loaded:", savedState.textDesign);
    } else {
      console.log("PIXI state not found or textDesign missing.");
    }



    
    callback();
  } catch (error) {
    console.error("Error loading PIXI state", error);

    
    callback();
  }
}







// export function loadStateForPIXI(pixiCanvas, stateString, callback) {
//     try {
//       const savedState = JSON.parse(stateString);
//       // Assume your PIXI canvas has a reference to the primary display object via __textDesign
//       const textDesign = pixiCanvas.__textDesign;
//       if (textDesign && savedState.textDesign) {
//         textDesign.x = savedState.textDesign.x;
//         textDesign.y = savedState.textDesign.y;
//         textDesign.width = savedState.textDesign.width;
//         textDesign.height = savedState.textDesign.height;
//         textDesign.rotation = savedState.textDesign.rotation;
//         textDesign.scale.set(savedState.textDesign.scaleX, savedState.textDesign.scaleY);
//         // Update filters if applicable (example for a displacement filter)
//         if (textDesign.filters && textDesign.filters[0] && savedState.textDesign.wrapping) {
//           textDesign.filters[0].scale.set(savedState.textDesign.wrapping, savedState.textDesign.wrapping);
//         }
//         console.log("PIXI state loaded:", savedState.textDesign);
//       } else {
//         console.log("PIXI state not found or textDesign missing.");
//       }
//       callback();
//     } catch (error) {
//       console.error("Error loading PIXI state", error);
//       callback();
//     }
//   }